import React  from 'react';
import {FieldViewProps} from "../../../../render/view";
import FieldProto from "../../../../proto/field-proto";

type Props = {
    field       : FieldProto;
    model       : any;
    className?  : string;
    iconClassName?  : string;
    options?    : any
    onClick?    : onClick
};

export default function FieldDocumentType_View(props:Props) {

    const value = _.get(props.model, props.field.fieldId, null)

    const noteType = gd.session.noteTypes.get(value)
    if (!noteType) return <div className="flex-row-left-center">Type not found</div>

    return  (
        <div className={Classes("flex-row-left-center lh-20 txt-truncate", props.className)}>
            <div className={Classes('ui5-ico-12 m-r-5', props.iconClassName, gd.const.note.icon[noteType.icon])}/>
            <div className="txt-truncate">{noteType.name}</div>
        </div>
    )
}
